import { ASSETS } from "@/lib/assets";

// Per-project case study content. Update copy + metrics here as needed.
export const CASE_STUDIES = {
  "lambda-lambda": {
    slug: "lambda-lambda",
    category: "Website Design & Development",
    title: "Lambda-Lambda Alumni Association",
    year: "2025",
    client: "Lambda-Lambda of Kappa Sigma",
    role: "Design & Build",
    liveUrl: "https://kappasigmaelon.org/",
    liveLabel: "kappasigmaelon.org",
    hero: "/lambda-menu.webp",
    summary:
      "A modern, welcoming home for an alumni community — bringing decades of history, events and giving into one polished, easy-to-manage platform.",
    brief:
      "The chapter needed to retire an aging, hard-to-update site and replace it with something that felt as proud and established as the association itself — while staying simple enough for volunteers to maintain.",
    challenge:
      "Years of content lived across disconnected pages with no clear hierarchy. Alumni struggled to find events, updates and ways to give back, and the old design didn't reflect the prestige of the organization.",
    approach: [
      "Restructured the entire information architecture around what alumni actually look for.",
      "Designed a warm, collegiate visual identity with a bold typographic system.",
      "Built a fast, responsive front-end with a friendly content-management workflow.",
      "Created clear pathways for events, membership and donations.",
    ],
    gallery: ["/lambda-composites.webp", "/lambda-homecoming.webp", "/lambda-megamenu.webp"],
    results: [
      { value: "100%", label: "Responsive across devices" },
      { value: "3x", label: "Faster page loads" },
      { value: "1 day", label: "To publish new updates" },
    ],
    testimonial: {
      quote:
        "The new site finally feels like us — polished, easy to navigate, and simple for our volunteers to keep current.",
      author: "Alumni Board",
    },
    next: "mrac",
  },
  mrac: {
    slug: "mrac",
    category: "Website Design & Development",
    title: "Meherrin River Arts Council",
    year: "2026",
    client: "Meherrin River Arts Council",
    role: "Design & Build",
    liveUrl: "https://www.mrac-arts.com/",
    liveLabel: "mrac-arts.com",
    hero: "/mrac-corporate.webp",
    summary:
      "A vibrant digital stage for a regional arts council — spotlighting performances, seasons and community programs with expressive, art-forward design.",
    brief:
      "MRAC wanted a site as expressive as the work they champion: something that could showcase a full season of events, sell the experience, and grow with the organization.",
    challenge:
      "Season line-ups, ticketing details and program information changed constantly, and the previous presentation didn't do the artistry justice or make it easy to act.",
    approach: [
      "Built an art-forward layout that lets imagery and color lead.",
      "Designed a flexible season/events structure that's quick to update.",
      "Paired the site with bold seasonal graphic design (see the 2026 poster).",
      "Optimized for discovery, sharing and clear calls to action.",
    ],
    gallery: [ASSETS.workMrac, "/mrac-visit.webp"],
    results: [
      { value: "Full season", label: "Programs, one clear home" },
      { value: "Art-first", label: "Design that leads with imagery" },
      { value: "Mobile-ready", label: "Beautiful on every screen" },
    ],
    testimonial: {
      quote:
        "Silver Schnauzer captured the spirit of our season and gave us a site we're genuinely proud to share.",
      author: "MRAC Team",
    },
    next: "mrac-poster",
  },
  "mrac-poster": {
    slug: "mrac-poster",
    category: "Graphic Design",
    title: "MRAC 2026 — Season Poster",
    year: "2026",
    client: "Meherrin River Arts Council",
    role: "Art Direction & Graphic Design",
    liveUrl: "https://www.mrac-arts.com/",
    liveLabel: "mrac-arts.com",
    hero: ASSETS.portPoster,
    portrait: true,
    summary:
      "A bold, collectible season poster that captures a full year of performances in a single, framable piece of art.",
    brief:
      "MRAC needed a headline visual for their 2026 season — something striking enough to hang on a wall, flexible enough to work across print and social, and unmistakably on-brand.",
    challenge:
      "A season poster has to do a lot at once: celebrate the line-up, stay readable at a glance, and feel like art in its own right — all while scaling from a printed poster down to a tiny social thumbnail.",
    approach: [
      "Set a confident typographic hierarchy that leads with the season and the shows.",
      "Built a rich, layered color palette and composition with real personality.",
      "Designed for print first, then adapted crops for web and social.",
      "Kept everything consistent with the MRAC website's art-forward identity.",
    ],
    gallery: [],
    results: [
      { value: "Print + digital", label: "One design, every format" },
      { value: "Framable", label: "A piece worth keeping" },
      { value: "On-brand", label: "Consistent with the MRAC site" },
    ],
    testimonial: {
      quote:
        "The poster became the face of our whole season — people asked where they could get a copy.",
      author: "MRAC Team",
    },
    next: "lambda-lambda",
  },
};

export const getCaseStudy = (slug) => CASE_STUDIES[slug];
